<div class="container grid">
    <h1 class="main-title text-half text-primary-base grid-12 m-none mt-base">MIS DATOS</h1>

    <div class="publication-card bg-grayscale-white mb-half pb-xlarge grid-12 grid-start-md-3 grid-md-8">
        <div class="images-perfil">
            <figure class="figure-perfil">
                <p class="text-grayscale-white text-xlarge text-center">Eo</p>
                <img class="image img-responsive" src="../../../assets/images/products/inmueble-test.png" alt="foto de perfil" />
            </figure>
        </div>
        <p class="text-left text-base text-grayscale-gray-5 mt-huge pt-medium">A continuación, ves todos los datos de tu cuenta para que puedas actualizarlos en el momento en que lo requieras. Por seguridad, el único dato que no puedes cambiar es tu correo electrónico.</p>
        <div class="grid">

            <h1 class="grid-12 text-thumb text-primary-base mt-large">Datos de acceso</h1>
            <div class="grid-12 grid-md-6">
                <mat-form-field appearance="outline" class="width-100">
                    <mat-label>Tipo de usuarios</mat-label>
                    <mat-select>
                        <mat-option value="option">Option</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" class="width-100">
                    <mat-label>Nombre y Apellido / Nombre Empresa</mat-label>
                    <input type="text" matInput placeholder="Nombre y Apellido / Nombre Empresa">
                </mat-form-field>
            </div>
            <div class="grid-12 grid-md-6">
                <mat-form-field appearance="outline" class="width-100">
                    <mat-label>Nombre de Usuario</mat-label>
                    <input type="text" matInput placeholder="Nombre de Usuario">
                </mat-form-field>
                <mat-form-field appearance="outline" class="width-100">
                    <mat-label>Correo Electrónico</mat-label>
                    <input type="email" matInput placeholder="Correo Electrónico">
                </mat-form-field>
            </div>
            <hr class="grid-12 perfil-border m-none">
            <h1 class="grid-12 text-thumb text-primary-base">Información de contacto</h1>
            <div class="grid-12 grid-md-6">
                <mat-form-field appearance="outline" class="width-100">
                    <mat-label>Departamento</mat-label>
                    <mat-select>
                        <mat-option value="option">Option</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="grid-12 grid-md-6">
                <mat-form-field appearance="outline" class="width-100">
                    <mat-label>Teléfono</mat-label>
                    <input type="tel" matInput placeholder="Teléfono">
                </mat-form-field>
            </div>
            <div class="grid-12 text-center mb-half">
                <mat-checkbox class="mr-small text-base text-grayscale-base">Contactar por llamada</mat-checkbox>
                <mat-checkbox class="text-base text-grayscale-base">Contactar por whatsapp</mat-checkbox>
            </div>
            <div class="grid-12 text-center mb-medium">
                <button class="grid-8 button secondary px-thumb rounded text-xsmall">Guardar datos</button>
            </div>
        </div>
    </div>
</div>